import { render, staticRenderFns } from "./EmploymentLeaveAllowancesTable.vue?vue&type=template&id=80f8fe8c"
import script from "./EmploymentLeaveAllowancesTable.vue?vue&type=script&lang=js"
export * from "./EmploymentLeaveAllowancesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports